<script lang="ts">
    
    import { onDestroy, onMount, setContext, SvelteComponent } from "svelte";
    import type { RealTimeEvent, RoomState } from "../../global";
    import type { Room } from "../../Model/Room";
    import { realTimeService, roomsService, uuidGenerator } from "../../Services";
    import type { EventsChannel } from "../../Services/EventsChannel";
    import Idle from "./Idle.svelte";
    import Playing from "./Playing.svelte";
    import Waiting from "./Waiting.svelte";
    import { Modal, ModalBody, ModalHeader } from "sveltestrap";
    import RoomSettings from "../../Components/Manager/RoomSettings.svelte";
    import { i18n } from "../../Services/i18n";

    export let roomId: string;

    const realTimeClientId = uuidGenerator.createUuid();

    const viewsMap: Record<RoomState, typeof SvelteComponent> = {
        'idle'    : Idle,
        'waiting' : Waiting,
        'playing' : Playing
    };

    let useView: RoomState = 'idle';
    let room: Room;
    let roomEvents: EventsChannel;
    let reloadInterval: ReturnType<typeof setInterval>;

    let openRoomSettingsModal = false;

    setContext('toggleRoomSettingsModal', toggleRoomSettingsModal);

    onMount(() => {
        init();
        // reloadInterval = setInterval(() => {
        //     if (useView !== 'playing') {
        //         location.reload();
        //     }
        // }, 15000);
    });

    onDestroy(() => {
        realTimeService.end();
        roomEvents?.destroy();
        clearInterval(reloadInterval);
    });

    async function init(): Promise<void> {
        try {
            
            room = await roomsService.getRoom(roomId);
            roomEvents = room.getEventsChannel();

            await realTimeService.start(realTimeClientId, room.id);
            roomEvents.on('updated', onRoomUpdated);
            room.state.subscribe(roomState => useView = roomState);
        } catch (error) {
            console.error(error);
        }
    }

    function onRoomUpdated(event: RealTimeEvent): void {
        room.showRoomQrInMonitor.set(event.data.showRoomQrInMonitor);
    }

    function toggleRoomSettingsModal(): void {
        openRoomSettingsModal = !openRoomSettingsModal;
    }

</script>

<div class="monitor">
    {#if room}
        <svelte:component this={viewsMap[useView]} {room} />
    {/if}
</div>

{#if room}
    <Modal isOpen={openRoomSettingsModal}>
        <ModalHeader toggle={toggleRoomSettingsModal}>{$i18n("Ajustes de sala")}</ModalHeader>
        <ModalBody>
            <RoomSettings roomId={roomId} on:saved={toggleRoomSettingsModal} />
        </ModalBody>
    </Modal>
{/if}

<style lang="scss">

    .monitor {
        --color-primary: #004681;
        --color-secondary: #FFD633;
        --color-invalid: rgb(238, 58, 17);
        --color-success: rgb(68, 182, 91);

        position: relative;
        width: 100vw;
        height: 100vh;

        :global(.monitor-view) {
            position: absolute;
            z-index: 2;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-image: url('/images/mobile-background.svg');
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
            color: #fff;
        }

        :global(img) {
            max-width: 100%;
        }
    }

</style>
